<template>
  <div class="servicesType">
    <div class="head row align-center column-s">
      <h1>Tipos de Serviço</h1>
      &nbsp;&nbsp;&nbsp;
      <Button :layout="showForm ? 'red-go' : 'green-go'" title="NOVO TIPO DE SERVIÇO" @click="showForm = !showForm">{{
        showForm ? "x" : "+" }}</Button>
      <transition name="slide">
        <div v-if="showForm" class="new grid-10">
          <ServicesTypeForm :form="form" />
        </div>
      </transition>
    </div>
    <div class="filters row column-s align-end justify-space">
      <div class="column grid-1 grid-12-s">
        <label>Status</label>
        <select v-model="filter.status">
          <option value="">Selecione</option>
          <option value="ativo">Ativo</option>
          <option value="inativo">Inativo</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Nome</label>
        <input type="text" v-model="filter.nome" placeholder="Nome" />
      </div>
      <div class="column grid-2 grid-12-s">
        <label for="etapa">Especialidade</label>
        <select v-model="filter.id_especialidade">
          <option value="">Selecione</option>
          <option v-for="e of especialidades" :value="e.id" :key="e.id">{{ e.nome }}</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Base de custo</label>
        <select v-model="filter.id_base_custo">
          <option value="">Selecione</option>
          <option v-for="e of base" :value="e.id" :key="e.id">{{ e.nome }}</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Tipo</label>
        <select v-model="filter.tipo">
          <option value="">Selecione</option>
          <option value="atendimento">Atendimento avulso</option>
          <option value="alocacao">Alocação</option>
        </select>
      </div>
      <Button layout="green-go" @click="load"><i class="fa fa-search" /> Listar</Button>
    </div>
    <div v-if="list && list.length && !loader.list" class="list">
      <template>
        <div class="head row justify-space">
          <div class="grid-1">ID</div>
          <div class="grid-2">Nome</div>
          <div class="grid-1">Tipo</div>
          <div class="grid-1">Dur. atendimento</div>
          <div class="grid-1">Dur. Alocação</div>
          <div class="grid-1">Forma</div>
          <div class="grid-1">Especialidade</div>
          <div class="grid-1">Status</div>
          <div class="grid-1">Criado em</div>
        </div>
        <div class="content">
          <div v-for="(item, i) of list" :key="'item' + i">
            <div class="line row justify-space align-center" @click="toggle(i)">
              <div class="grid-1">{{ item.id }}</div>
              <div class="grid-2">{{ item.nome }}</div>
              <div class="grid-1">{{ item.tipo }}</div>
              <div class="grid-1">{{ item.duracao_atendimento }}</div>
              <div class="grid-1">{{ item.duracao_alocacao }}</div>
              <div class="grid-1">{{ item.forma_atendimento }}</div>
              <div class="grid-1">{{ item.nome_especialidade }}</div>
              <div class="grid-1">{{ item.status }}</div>
              <div class="grid-1">{{ item.criado_em | date }}</div>
            </div>
            <div v-if="item.show" class="edit row wrap column-s">
              <ServicesTypeForm v-if="item.info" :form="item.info" />
              <Loader layout="small" v-else />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="loader.list" class="column align-center justify-center">
      <Loader layout="small" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import ServicesTypeForm from "@/views/admin/components/ServiceTypeForm.vue";

var initForm = {
  nome: "",
  id_especialidade: 1,
  id_base_custo: 1,
  id_orientacao: null,
  interno: false,
  duracao_atendimento: "",
  duracao_folga: "0000",
  duracao_alocacao: 1,
  folga_obrigatoria: "0000",
  tipo_deslocamento: "variavel",
  valor_deslocamento_fixo: null,
  limite_km_deslocamento_variavel: null,
  valor_deslocamento_variavel: null,
  forma_atendimento: "presencial",
  tipo: "atendimento",
  valor_orcado_job_interior: "0000",
  valor_job_interior: "0000",
  valor_orcado_job_interior_diferenciado: "0000",
  valor_job_interior_diferenciado: "0000",
  valor_orcado_extra_interior: "0000",
  valor_extra_interior: "0000",
  valor_orcado_extra_interior_diferenciado: "0000",
  valor_extra_interior_diferenciado: "0000",
  valor_orcado_job_capital: "0000",
  valor_job_capital: "0000",
  valor_orcado_job_capital_diferenciado: "0000",
  valor_job_capital_diferenciado: "0000",
  valor_orcado_extra_capital: "0000",
  valor_extra_capital: "0000",
  valor_orcado_extra_capital_diferenciado: "0000",
  valor_extra_capital_diferenciado: "0000",
  valor_fat_job_interior: "0000",
  valor_fat_job_interior_diferenciado: "0000",
  valor_fat_extra_interior: "0000",
  valor_fat_extra_interior_diferenciado: "0000",
  valor_fat_job_capital: "0000",
  valor_fat_job_capital_diferenciado: "0000",
  valor_fat_extra_capital: "0000",
  valor_fat_extra_capital_diferenciado: "0000",
};
export default {
  name: "ServicesType",
  components: { Loader, Button, ServicesTypeForm },
  data() {
    return {
      filter: { status: "", nome: "", id_especialidade: "", id_base_custo: "", tipo: "" },
      list: [],
      base: [],
      especialidades: [],
      loader: {
        list: false,
        form: false,
      },
      showForm: false,
      search: "",
      form: { send: this.create, ...initForm, change: this.change },
    };
  },
  methods: {
    ...mapActions("admin", [
      "SERVICESTYPE_NEW",
      "SERVICESTYPE_DEL",
      "SERVICESTYPE_UPDATE",
      "SERVICESTYPE_LIST",
      "SERVICESTYPE_GET",
      "BASECOST_LIST",
      "ESPECIALITY_LIST"
    ]),
    async change(f, v) {
      if (f == 'reset') this.form = { ...this.form, valor_job_interior: "0000", valor_job_interior_diferenciado: "0000", valor_extra_interior: "0000", valor_extra_interior_diferenciado: "0000", valor_job_capital: "0000", valor_job_capital_diferenciado: "0000", valor_extra_capital: "0000", valor_extra_capital_diferenciado: "0000", valor_orcado_job_interior: "0000", valor_orcado_job_interior_diferenciado: "0000", valor_orcado_extra_interior: "0000", valor_orcado_extra_interior_diferenciado: "0000", valor_orcado_job_capital: "0000", valor_orcado_job_capital_diferenciado: "0000", valor_orcado_extra_capital: "0000", valor_orcado_extra_capital_diferenciado: "0000" }
      else this.form[f] = v;
      this.$forceUpdate()
    },
    async load() {
      this.loader.list = true;
      await this.SERVICESTYPE_LIST({ ...this.filter }).then(({ data }) => (this.list = data));
      this.loader.list = false;
    },
    create(form) {
      return this.SERVICESTYPE_NEW(form).then(({ status }) => {
        if (status == 201) {
          this.form = {
            ...{ send: this.create, change: this.change },
            ...initForm,
          };
          this.load();
          this.showForm = false;
        }
      });
    },
    del(item) {
      if (confirm(`Deseja excluir ${item.nome}?`)) {
        return this.SERVICESTYPE_DEL(item).then(() => this.load());
      }
    },
    update(item) {
      this.SERVICESTYPE_UPDATE(item).then(({ status }) => {
        if (status == 200) this.load();
      });
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;
      if (this.list[index].show) {
        await this.SERVICESTYPE_GET(this.list[index].id).then(({ data }) => {
          this.list[index].info = data || {};
          this.list[index].info.update = true;
          this.list[index].info.send = (form) => this.update(form);
          this.list[index].info.del = (form) => this.del(form);
          this.list[index].info.change = (f, v) => this.list[index].info[f] = v
          this.list = [...this.list];
        });
      } else this.list = [...this.list];
    },
  },
  beforeMount() {
    this.ESPECIALITY_LIST().then(({ data }) => (this.especialidades = data || []));
    this.BASECOST_LIST({}).then(({ data }) => (this.base = data));
  },
  mounted() {
    this.$parent.$children[0].changeMenu("list");
  }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.servicesType
  @include page
  .filters button
    margin-right: 20px
  .loader
    margin-top: 12%
</style>
